import React, { useState, useEffect, useMemo, useRef, createRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { Modal, ModalTitle, ModalBody } from '@vds/modals';
import { Body, Title } from '@vds/typography';
import { Button } from '@vds/buttons';
import { getFiosTv,setTVRecordingSelectionvalue, saveViewSelection, updateCart, setTvHdSetupSelection,updateSerivcesInCartbyBDV } from '../containers/actions';


const RemoveServiceModals=(props)=>{
  
  const RemoveServiceModalWindow = styled(Modal)`
    height: 285px;
    width:560px;
    .removeModalContent{
      margin:45px;
    }
    @media only screen and (max-width: 600px) {
        position: absolute;
        top: 10px;
        right:10px;
        left:9px;
        width: 98vw;
        height: 97vh;
        max-width: 95vw;
        > div:first-child {
            padding:2px;
        }
    }
    > div:first-child {overflow:hidden;}
    `;
    
    const ButtonWrapper = styled.div`
      display: flex;
      button {
        margin: 18px 10px 10px 0;
        width :100%;    
      }
      padding-left: 0px;
      @media (min-width: 768px) {
        justify-content: flex-start;
      }
      @media (max-width: 768px) {
        button {
          justify-content: center;
          width: 100%;
          display: grid;
        }
      }
    `;
    const  ChangeModal = (modal) => {
        props.OpenCloseModal(modal)	
        }
    const ConfirmRemoveTVService=()=>{ 
      props.updateCart({type:"FIOSTV",data:{"PlanSelection":{"OldID":props?.OldID,"NewID":""}}})
      props.resetTVSubHeaderCall();
	    props.resetTvAddonsSection();
      props.OpenCloseModal(false)
        }
        const CancelRemoveTVService=(cancel)=>{
            props.OpenCloseModal(cancel)		
        }
    return (
        <RemoveServiceModalWindow
                    ariaLabel=""
                    opened={true}					
					onOpenedChange={ChangeModal}>
            <div className='removeModalContent'>
                    <ModalTitle>
                        <Title size="medium" primitive="h2">Are you sure you want to remove this service?</Title>
                    </ModalTitle>
                    <ModalBody>
                        <div>
							<p>Removing will delete your added TV service choices.</p>
                              <ButtonWrapper className='disp-inl'>
                                   <Button onClick={() => ConfirmRemoveTVService()} width="100%" >Remove TV service</Button>
							       <Button secondary width="100%" 
								   onClick={()=>CancelRemoveTVService(false)} >Do not remove</Button>
                             </ButtonWrapper>						
     .                   </div>
                    </ModalBody>
                    </div>
                </RemoveServiceModalWindow>
    )
}
const mapStateToProps = (state, props) => {
  return {

}}
const mapDispatchToProps = (dispatch) => ({
	updateCart: (data) => dispatch(updateCart(data))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RemoveServiceModals));